import request from '@/utils/request';

// 发起上报短信验证码校验签约
export const alipayCallbackSMSPay = ( data) => request({
  url: '/huanxinxiang-service/v1/alipay-callback-sms-pay/',
  method: 'post',
  data,
});

